import { defineMock } from '@alova/mock'

export default defineMock({})
